// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"747":"633e50a4","918":"633e50a4"}[chunkId] + ".chunk.css";
};